import PaperlessBillingTurnonPopup from "../../Centralized/AccountPreferences/PB/Presentational/PaperlessBillingTurnonPopup";
import ViewEditPaperlessBilling from "../../Centralized/AccountPreferences/PB/Presentational/ViewEditPaperlessBilling";
import PaperlessBillingTurnoffPopup from "../../Centralized/AccountPreferences/PB/Presentational/PaperlessBillingTurnoffPopup";
import ConfirmationPopup from "../../Centralized/AccountPreferences/PB/Presentational/ConfirmationPopup";
import PaperlessBillingDeEnrollConfirmPopup from "../../Centralized/AccountPreferences/PB/Presentational/PaperlessBillingDeEnrollConfirmPopup";

const BillPayHelper = {
  getAccountData(){
    let accountData = {
        Name: "", contractAccountNumber: "", houseNumber: "", streetAddress: "", city: "", state: "", zipcode: "", obEnrollmentFlag: "", isEligible: "",
        nextStatementDate: "", bpNumber: "", postBoxNumber:"", supplement:"", 
    };
    accountData.Name = this.state.customerAccountDetails.customerAccountListData[0].customerAccountName;
    accountData.bpNumber = this.state.customerAccountDetails.customerAccountListData[0].customerNumber;
    accountData.postBoxNumber = this.state.customerAccountDetails.customerAccountListData[0].mailingAddress.poBox;
    accountData.state = this.state.customerAccountDetails.customerAccountListData[0].mailingAddress.region;
    accountData.city =  this.state.customerAccountDetails.customerAccountListData[0].mailingAddress.city;
    accountData.houseNumber = this.state.customerAccountDetails.customerAccountListData[0].mailingAddress.houseNumber;
    accountData.zipcode = !_.isEmpty(this.state.customerAccountDetails.customerAccountListData[0].mailingAddress.poPostalCode)?this.state.customerAccountDetails.customerAccountListData[0].mailingAddress.poPostalCode:this.state.customerAccountDetails.customerAccountListData[0].mailingAddress.postalCode;
	accountData.streetAddress =  this.state.customerAccountDetails.customerAccountListData[0].mailingAddress.street;
    accountData.supplement = this.state.customerAccountDetails.customerAccountListData[0].mailingAddress.supplement;
    accountData.contractAccountNumber = this.state.customerAccountDetails.customerAccountListData[0].contractAccountNumber;
    this.state.customerAccountDetails.customerAccountListData[0].eligibilityData ? this.state.customerAccountDetails.customerAccountListData[0].eligibilityData.forEach(element => {
        if (element.programDescription === "OBP") {
            accountData.obEnrollmentFlag = element.enrolledFlag;
            accountData.isEligible = element.eligibilityFlag;
        }
    }) : null;
    accountData.nextStatementDate = this.state.customerAccountDetails.customerAccountListData[0].nextStatementDate;
    return accountData;
},
popupCallback(d, unselected, selectAllFlag, contractAccountCount) {
  const updatedState = { ...this.state.paperlessBilling };
  updatedState.data = d, updatedState.unselected = unselected, updatedState.selectAllflag = selectAllFlag, updatedState.contractAccountCount = contractAccountCount, this.setState(updatedState);
},
    submitClick() {
      window.aUtils.sendAAEvent("button", "paperlessBillingTurnOn");
      this.popupCallback();
      let updatedState = { ...this.state.paperlessBilling };
      if (!_.isEmpty(updatedState.data)) {
        updatedState.accountObj = this.state.paperlessBilling.data.map(function (selectedcact) {
          return { customerAccountNumber: selectedcact, contractAccountNumber: selectedcact, };
        });
      } else {
        let cact = parseInt(this.getAccountData().contractAccountNumber);
        updatedState.accountObj = [{ customerAccountNumber: cact, contractAccountNumber: cact }];}
      app.logger.getLogger().info("Paperless Billing Enroll: Submit");
      if (!this.checkLoginEmail() && _.isEmpty(this.customerData.emailAddresses)) {
        let loginEmail = { value: app.appService.getUserInfo().email };
        app.settingsService.getPaperlessBillingModifyCustPrefs(loginEmail, 'I').then(
          (response) => {
            app.settingsService.getPaperlessBillingEnrollDetails(updatedState.accountObj, app.appService.getUserInfo().profileData, updatedState.unselected, updatedState.selectAllflag, updatedState.contractAccountCount).then(
              (res) => {
                updatedState.enrolledCount = res.length, updatedState.enrollResponse = res;
                updatedState.isPbEnrollConfirm = true;
                if (res[0].transactionOutcome) {
                  errorPbEnrollMsg = ErrorMessages[res[0].transactionOutcome];
                  updatedState.pbEnrollErrMsg = errorPbEnrollMsg, updatedState.enrollResponse = res;
                } else {
                  updatedState.isPbEnrollConfirm = true, updatedState.isPbEnrollConfirmTest = true, updatedState.pbEnroll = false;
                  if (res.length === 1 && res[0].transactionOutcome === null) {
                    updatedState.enrolledCact = res[0].accountNumber; }
                  updatedState.isPbEnrollConfirmTest = true, updatedState.showPbPopUp = false, updatedState.enrolledCact = res.contractAccountNumber, updatedState.checked = true, updatedState.confirmObj = res;
                  updatedState.pbEnroll = false; }
                window.scrollTo(0, 0);
                this.setState({paperlessBilling:updatedState});
              }, (error) => {
                updatedState.checked = false, updatedState.isPbEnrollConfirm = false, updatedState.pbBulkEnrollConfirm = true, updatedState.isPbEnrollConfirm = true;//updatedState.errorEnrollFlag=true;
                this.handleServiceError(error);
                this.setState({paperlessBilling:updatedState});});
          }, (error) => {
            updatedState.checked = false,
              this.handleServiceError(error);
            this.setState({paperlessBilling:updatedState}); } ); }
      else {
        app.settingsService.getPaperlessBillingEnrollDetails(updatedState.accountObj, app.appService.getUserInfo().profileData, updatedState.unselected, updatedState.selectAllflag, updatedState.contractAccountCount).then(
          (res) => {
            updatedState.enrolledCount = res.length, updatedState.enrollResponse = res;
            let errorPbEnrollMsg = '';
            if (res[0].transactionOutcome) {
              errorPbEnrollMsg = ErrorMessages[res[0].transactionOutcome], updatedState.pbEnrollErrMsg = errorPbEnrollMsg, updatedState.enrollResponse = res;
            } else {
              updatedState.isPbEnrollConfirmTest = true, updatedState.showPbPopUp = false;
              if (res.length === 1 && res[0].transactionOutcome === null) {
                updatedState.enrolledCact = res[0].accountNumber; }
              updatedState.enrolledCact = res.contractAccountNumber, updatedState.confirmObj = res, updatedState.checked = true, updatedState.pbEnroll = false;
            }
            window.scrollTo(0, 0);
            this.setState({paperlessBilling:updatedState});
          },
          (error) => {
            updatedState.checked = false, updatedState.isPbEnrollConfirm = false, this.handleServiceError(error);
            this.setState({paperlessBilling:updatedState}); });}
    },
    //for de enroll
    submitDeenrollClick () {
      window.aUtils.sendAAEvent("button","paperlessBillingTurnOff");
      const updatedState = { ...this.state.paperlessBilling };
      let currPaprRecord = this.props.paprRecord || this.desinglePaprRec;
      let ebillpaprRecord = this.state.ebillpaprRecord;  
      app.logger.getLogger().info("Paperless Billing DeEnroll: Submit");
      app.settingsService.getPaperlessBillingDeEnrollDetails(this.state.customerAccountDetails.customerAccountListData[0].customerNumber, ebillpaprRecord.record, app.appService.getUserInfo().profileData, this.state.customerAccountDetails.customerAccountListData[0].contractAccountNumber).then(
        (res) => {
          let errorPbMsg='';
          updatedState.confirmObj = res,updatedState.checked = false, updatedState.pbDeEnroll = false, updatedState.deEnrollConfirmPopup = true, updatedState.yesCancelDeEnroll = true;//to close turn off popup 
          window.scrollTo(0, 0);
          // window.location.reload();
          this.setState({paperlessBilling:updatedState});
		this.setState(updatedState);
        },
        (error) => {
          updatedState.checked = true,updatedState.isPbDeEnrollConfirm=false,        
          this.handleServiceError(error);
          this.setState({paperlessBilling:updatedState}); } );
  
    },
    getCustomerData(reqObj,popUpFlag) {
      this.getAccountData();
      let updatedState = { ...this.state.paperlessBillingData };
      app.settingsService.getCustomerPreferences(reqObj).then(
        (res) => {
          this.customerData.emailAddresses = res.record;
          this.customerData.emailAddresses.map((record)=>{
            if(record.category === "PAPR"){
              this.singlePaprRec.record.push(record);
              this.desinglePaprRec.record.push(record);
            }
          });
          let emails = [];
          if (res && res.record.length) {
            res.record.map((record) => {
              emails.push(record.email_id);
              if (record.record_guid !== null && record.category === "PAPR") {
                updatedState.enrolledEmail = record.email_id;
              }
              if (record.standardIndicator === "X") {
                updatedState.primaryEmail = record.email_id;
              } }); }
          updatedState.emails = emails;
		app.appService.setLocalStorage('pbemails', emails);
          switch(popUpFlag){
            case 'enroll':{
              this.setState({ paperlessBillingData: updatedState,paperlessBilling: { pbEnroll: true } });
              break;
            }
            case 'deEnroll':{
              this.setState({ paperlessBillingData: updatedState,paperlessBilling: { pbDeEnroll: true } });
              break;
            }
            case 'viewEdit':{
              this.setState({ paperlessBillingData: updatedState,paperlessBilling: { viewEditPopUp: true } });
              break;
            }
          }
        }), (error) => {
          this.handleServiceError(error);
        };
  
    },
    //---ebill-------single----bill n payment
    getEbillPrefrencesData(reqObj) {
      this.getAccountData();
      let mainBpNumber = app.appService.getUserInfo().profileData.accountData.mainBusinessPartner.businessPartnerNumber;
      app.settingsService.getEbillPrefrences(reqObj).then(
        (response) => {
          this.setState({ ebillpaprCount: response.customerEbillPreferences.results[0].count });
          this.pbEmailAddresses.emailAddresses = response.record;
           let ebillpaprRecord={record:[]}, ebillpaprSold={record:[]}, ebillpaprAuth={record:[]};
          let res=response.customerEbillPreferences.results[0].qryObjSumQryBPChnlSumNav.results;
		app.appService.setSessionstorage('pbBuPartner', res[0].buPartner);
		app.appService.setSessionstorage('pbBuPartner2', res[0].buPartner2);
        res.map((record) => {
		let result=record.qryBPChnlSumQryPreSumNav.results;
            result.map((result) => {
            ebillpaprRecord.record.push(result);
            (mainBpNumber === record.buPartner || record.buPartner2) ? ebillpaprSold.record.push(result) : ebillpaprAuth.record.push(result);
            });
            //ebillpaprRecord.record.push(record.qryBPChnlSumQryPreSumNav.results[0]);
          });
        let preferenceData =this.getFormattedPreferenceData(ebillpaprSold, 'soldTo');
        let preferenceDataAuth = this.getFormattedPreferenceData(ebillpaprAuth, 'AuthTo');
        this.setState({ebillpaprRecord:ebillpaprRecord, ebillpaprSold:ebillpaprSold, ebillpaprAuth:ebillpaprAuth, preferenceData:preferenceData, preferenceDataAuth:preferenceDataAuth }, ()=>{});
        }), (error) => {
          this.handleServiceError(error);
        };    },
    checkLoginEmail() {
      let isLoginEmail = false;
      let loginEmail = app.appService.getUserInfo().email;
  
      _.each(this.state.paperlessBillingData.emails, function (record) {
        if (record.email === loginEmail)
          isLoginEmail = true;
      });
      return isLoginEmail;
    },
    handleServiceError(error) {
      app.logger.getLogger().info("Paperless Billing Enroll: Handle service error");
      app.logger.getLogger().info(error);
      this.setState({ isGlobalError: true });
    },
    getPBEnrollPopUp(){
      let accountData = this.getAccountData();
      return <PaperlessBillingTurnonPopup containerCallback={this.popupCallback} data={this.state.paperlessBilling.data} contractAccountNumber={this.state.customerAccountDetails.customerAccountListData[0].contractAccountNumber} contractAccountResults={this.state.customerAccountDetails.customerAccountListData[0]} accType={this.accType} accountData={accountData} nextStDate={this.state.customerAccountDetails.customerAccountListData[0].nextStatementDate} bpNumber={this.bpNumber} submitClick={this.submitClick} isOpen={this.cancelButtonHandler.bind(this)} primaryEmail={this.state.paperlessBillingData.primaryEmail} isPbEnrollConfirm={this.state.paperlessBilling.isPbEnrollConfirm} pbEnrollErrMsg={this.state.paperlessBilling.pbEnrollErrMsg}
      />;
    },
  getPBDeEnrollPopUp(){
      let accountData = this.getAccountData();
      return <PaperlessBillingTurnoffPopup accountData={accountData} submitDeenrollClick={this.submitDeenrollClick} isOpen={this.cancelButtonHandlerTurnoffPopup.bind(this)} isPbDeEnrollConfirm={this.state.paperlessBilling.isPbDeEnrollConfirm} pbEmailAddresses={this.pbEmailAddresses} ebillpaprCount={this.state.preferenceDataAuth.emailSet.length} />;
  },
  getViewEditPopUp() {
      let accountData = this.getAccountData();
      return <ViewEditPaperlessBilling emails={this.state.paperlessBillingData.emails} loginEmail={app.appService.getUserInfo().email} accountData={accountData} isOpen={this.cancelViewButtonHandlers.bind(this)} primaryEmail={this.state.paperlessBillingData.primaryEmail} enrolledEmail={this.state.enrolledPbEmail} prefData={this.singlePaprRec.record} bpNumber={this.state.customerAccountDetails.customerAccountListData[0].customerNumber} enrolledEmailObj={this.state.enrolledPbEmail} customerData={this.customerData} ebillpaprRecord={this.state.ebillpaprRecord} preferenceData={this.state.preferenceData} preferenceDataAuth={this.state.preferenceDataAuth} dropDownData={this.customerData} closePopUp={this.closeViewEditConfirmPopup.bind(this)} />;
  },
  getPBConfirmPopUp(){
      let accountData = this.getAccountData();
      return <ConfirmationPopup nextStDate={this.state.customerAccountDetails.customerAccountListData[0].nextStatementDate} enrolledCount={this.state.paperlessBilling.enrolledCount} primaryEmail={this.state.paperlessBillingData.primaryEmail} accType={this.accType} accountData={accountData} isOpen={this.cancelButtonHandler.bind(this)} isConfOpen={this.cancelConfirmationButtonHandlers.bind(this)} />;
    },
    getdeEnrollConfirmPopup() {
      let accountData = this.getAccountData();
      return <PaperlessBillingDeEnrollConfirmPopup prefenceDataCount={null} ebillpaprCount={this.state.preferenceDataAuth.emailSet.length} accountData={accountData} closePopup={this.closeButtonHandlerDeEnrollPopup.bind(this)} yesCancelDeEnroll={this.state.yesCancelDeEnroll} />;
    },
  cancelViewButtonHandlers() {
      this.setState({ paperlessBilling: { viewEditPopUp: false }, deEnrollConfirmPopup: true, yesCancelDeEnroll: false }, () => { });
  },
  cancelButtonHandler() {
      this.setState({ paperlessBilling: { pbEnroll: false }, data: 1 });
  },
  cancelButtonHandlerTurnoffPopup() {
      this.setState({ paperlessBilling: {pbDeEnroll: false }});
      this.setState({deEnrollConfirmPopup: true }, () => { });
      this.setState({yesCancelDeEnroll: false }, () => { });
  },
  closeButtonHandlerDeEnrollPopup(){
    this.setState({ deEnrollConfirmPopup: false });
    window.location.reload();
  },
  cancelConfirmationButtonHandlers() {
      let pbParam = {...this.state.paperlessBilling};
      pbParam.isPbEnrollConfirmTest = false;
      this.setState({paperlessBilling:pbParam});
  },
  //-----------------ebill-----ViewEditConfirmPopup------
   closeViewEditConfirmPopup(){ window.location.reload(); },

  isEnrolledInPA (futureDue1Amount, futureDue2Amount, finalCallExtStartDate, finalCallExtSEndDate){
    return (futureDue1Amount !== 0) || (futureDue2Amount !== 0) || (finalCallExtStartDate !== '0000-00-00' && finalCallExtSEndDate !== '0000-00-00');
}, 
capturingAnalytics(maskedEmail){
  app.appService.setSessionstorage('customerAccountDetails', `|${app.appService.getSessionstorage('acctTypeDSS')}|PB=${this.state.isObIneligible ? "Ineligible" : !_.isEmpty(maskedEmail) ? 'On' : 'Off'}|AP=${this.state.isDpIneligible ? "Ineligible" : !_.isEmpty(this.state.associatedDpBank) ? 'On' : 'Off'}`); },
  
  formatMailingAddress(mailingAddr) {
    let { careOfName, houseNumber, street, supplement, city, region, postalCode, poBox, poPostalCode } = mailingAddr,parts = [];
    return BillPayHelper.getCommaSeparatedAddr([[careOfName?`${this.capitaliser(careOfName)}`:null],[poBox?`PO box ${poBox}`:null],[houseNumber, this.capitaliser(street)],[supplement],[this.capitaliser(city)],[region, poPostalCode? this.capitaliser(poPostalCode.split('-')[0]):postalCode.split('-')[0]]]);
},

getCommaSeparatedAddr(fields) {
    let strs = [];
    for (let i=0; i<fields.length; i++) {
        let parts = [];
        for (let j=0; j<fields[i].length; j++)
            if (fields[i][j])
                parts.push(fields[i][j]);
        if (parts.length){
            strs.push(parts.join(" ")); }}
    return strs.join(", ");
},
capitaliser (mySentence) {
  let words = mySentence?mySentence.trim().split(" "):[];
  mySentence?words.length <1 ? words.push(mySentence) : null:null;
  let reframedSentence = words.map((word) => {
      let reframed = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      return reframed;}).join(" ");
  return reframedSentence;
},
fetchLoaderType(){
  const userType = app.appService.getUserInfo() && app.appService.getUserInfo().profileData && app.appService.getUserInfo().profileData.profile ? app.appService.getUserInfo().profileData.profile.userType : null;
  return userType ? (userType === 'TP' || userType === 'ABS') ? 'old' : 'new' : null;
},
  setGenericAccountTypeSession(response) {
    let { customerAccountListData, totalCustomerAccountCount } = response;
    let customerAccountListDataLength = customerAccountListData.length;
    let genericAccountType = "unknown" + " | " + totalCustomerAccountCount;
    let isCommercial = false;

    for (let i = 0; i < customerAccountListDataLength; i++) {
      const eligibilityData = customerAccountListData[i].eligibilityData;
      if (eligibilityData && eligibilityData[0] && 
        eligibilityData[0].customerClass !== app.appUtil.getAppConstants().CUSTOMER_CLASS
      ) {
        isCommercial = true;
        break;}}

    if (isCommercial) {
      genericAccountType = app.appUtil.getAppConstants().Business + " | " + totalCustomerAccountCount;}
    else if (totalCustomerAccountCount <= 10) {
      genericAccountType = app.appUtil.getAppConstants().residential + " | " + totalCustomerAccountCount;}

    app.appService.setLocalStorage('genericAccountType', genericAccountType);
  },
  getFormattedPreferenceData(Obj, type){
    let preferenceData={emailSet:[]};
    _.each(Obj.record, function(email){
        let preferenceSavedDateMilliSec = email.validFromDate ? email.validFromDate.indexOf('/')===0 ? email.validFromDate.slice(6,-2) : email.validFromDate : null;
        let preferenceSavedEDMDate = preferenceSavedDateMilliSec ? app.appUtil.DateUtil.getEDMDate(parseInt(preferenceSavedDateMilliSec)) : null;
        let data={
          solution: 'U', objectType: 'ISUACCOUNT', objectKey: email.relationshipObjectKey || '', contractAccountNumber: email.contractAccountNumber, category: 'PAPR', messageType: 'EBILL',
          buPartner: email.buPartner, channel: 'INT', recordGUID: email.recordGUID || 'NEW', email: email.value || "", type: type,
          validFromDate: email.validFromDate, validFromTime: email.validFromTime, validToDate: email.validToDate, validToTime: email.validToTime,
            removeFromDate: preferenceSavedEDMDate, buPartner2: email.buPartner2, relationshipObjectType: email.relationshipObjectType, relationshipObjectKey: email.relationshipObjectKey
        };
          preferenceData.emailSet.push(data);
    });
    return preferenceData;
  }};
  
  
  export default BillPayHelper;
